import React, { useState } from "react";
import "./appWrapper.scss";
import { useNavigate } from "react-router";
import { accountPath, promotionsPath, restaurantListPath, rewardsPath } from "../main";
import { IoHomeSharp } from "react-icons/io5";
import { FaTrophy } from "react-icons/fa";
import { MdAccountCircle } from "react-icons/md";
import { FaTag } from "react-icons/fa";

export const AppWrapper = (props: { children: React.ReactNode }) => {
    const navigate = useNavigate();
    const [activeTab, setActiveTab] = useState("restaurantList");

    return (
        <>
            <div className="navigation-wrapper">
                <div className="content">{props.children}</div>

                <div className="bottom-navigation">
                    <div
                        className={`tab`}
                        onClick={() => {
                            setActiveTab("restaurantList");
                            navigate(restaurantListPath);
                        }}
                    >
                        <div>
                            <div className={`tab-icon ${activeTab === "restaurantList" ? "active" : ""}`}>
                                <IoHomeSharp />
                            </div>
                            <div className="tab-name">Home</div>
                        </div>
                    </div>
                    <div
                        className={`tab`}
                        onClick={() => {
                            setActiveTab("promotions");
                            navigate(promotionsPath);
                        }}
                    >
                        <div>
                            <div className={`tab-icon ${activeTab === "promotions" ? "active" : ""}`}>
                                <FaTag />
                            </div>
                            <div className="tab-name">Coupons</div>
                        </div>
                    </div>
                    <div
                        className={`tab`}
                        onClick={() => {
                            setActiveTab("rewards");
                            navigate(rewardsPath);
                        }}
                    >
                        <div>
                            <div className={`tab-icon ${activeTab === "rewards" ? "active" : ""}`}>
                                <FaTrophy />
                            </div>
                            <div className="tab-name">Rewards</div>
                        </div>
                    </div>
                    <div
                        className={`tab`}
                        onClick={() => {
                            setActiveTab("accountSettings");
                            navigate(accountPath);
                        }}
                    >
                        <div>
                            <div className={`tab-icon ${activeTab === "accountSettings" ? "active" : ""}`}>
                                <MdAccountCircle />
                            </div>
                            <div className="tab-name">Account</div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};
